<template>
  <div class="tags-view-container">
    <div class="tags-wrapper" ref="scrollContainer">
      <router-link
        v-for="tag in visitedViews"
        :key="tag.path"
        ref="tag"
        class="tags-view-item"
        :class="{ active: isActive(tag) }"
        :to="tag.fullPath"
        @contextmenu.prevent.native="openMenu(tag, $event)"
        @click.middle.native="!isAffix(tag) && closeSelectedTag(tag)"
      >
        {{ tag.title }}
        <i
          v-if="!isAffix(tag)"
          class="el-icon-close close-icon"
          @click.prevent.stop="closeSelectedTag(tag)"
        ></i>
      </router-link>
    </div>

    <ul v-show="menuVisible" class="contextmenu" :style="{ left: left + 'px', top: top + 'px' }">
      <li @click="refreshSelectedTag(selectedTag)">刷新页面</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭当前</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags">关闭全部</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TagsView',
  data() {
    return {
      menuVisible: false,
      selectedTag: {},
      left: 0,
      top: 0
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    routes() {
      return this.$store.getters.routers || []
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.meta && route.meta.title) {
          this.$store.dispatch('addView', route)
        }
        // 切换路由后将当前标签滚动到可视区域
        this.$nextTick(() => {
          this.moveToCurrentTag()
        })
      },
      immediate: true
    },
    menuVisible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  created() {
    this.initAffixTags()
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.closeMenu)
  },
  methods: {
    // 初始化固定标签（如首页）
    initAffixTags() {
      const affixTags = this.filterAffixTags(this.routes)
      affixTags.forEach(tag => {
        this.$store.dispatch('addView', tag)
      })
    },
    filterAffixTags(routes, basePath) {
      let tags = []
      routes.forEach(route => {
        const routePath = this.resolvePath(basePath, route.path)
        if (route.meta && route.meta.affix) {
          tags.push({
            fullPath: routePath,
            path: routePath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          tags = tags.concat(this.filterAffixTags(route.children, routePath))
        }
      })
      return tags
    },
    resolvePath(basePath, routePath) {
      if (!basePath) return routePath.startsWith('/') ? routePath : '/' + routePath
      if (routePath.startsWith('/')) return routePath
      return basePath.replace(/\/$/, '') + '/' + routePath
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags) return
      const list = Array.isArray(tags) ? tags : [tags]
      const current = list.find(item => item.$el && item.$el.classList.contains('active'))
      if (current && current.$el.scrollIntoView) {
        current.$el.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' })
      }
    },
    openMenu(tag, e) {
      const menuWidth = 120
      const menuHeight = 150
      this.selectedTag = tag
      this.left = Math.min(e.clientX, document.body.clientWidth - menuWidth - 8)
      this.top = Math.min(e.clientY, document.body.clientHeight - menuHeight - 8)
      this.menuVisible = true
    },
    closeMenu() {
      this.menuVisible = false
    },
    refreshSelectedTag(view) {
      this.closeMenu()
      this.$store.dispatch('delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace('/redirect' + fullPath)
        })
      })
    },
    closeSelectedTag(view) {
      this.closeMenu()
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          if (visitedViews.length > 0) {
            const latest = visitedViews[visitedViews.length - 1]
            this.$router.push(latest.fullPath)
          } else {
            this.$router.push('/home')
          }
        }
      })
    },
    closeOthersTags() {
      this.closeMenu()
      this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
        this.$router.push(this.selectedTag.fullPath)
      })
    },
    closeAllTags() {
      this.closeMenu()
      this.$store.dispatch('delAllViews').then(({ visitedViews }) => {
        if (visitedViews.length > 0) {
          const latest = visitedViews[visitedViews.length - 1]
          this.$router.push(latest.fullPath)
        } else {
          this.$router.push('/home')
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 10;

  .tags-wrapper {
    height: 34px;
    padding: 3px 8px;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      height: 0;
    }
  }

  .tags-view-item {
    display: inline-block;
    position: relative;
    height: 26px;
    line-height: 24px;
    padding: 0 10px;
    margin-left: 4px;
    border: 1px solid #d8dce5;
    color: #495060;
    background: #fff;
    font-size: 12px;
    border-radius: 2px;
    cursor: pointer;
    vertical-align: top;

    &:hover {
      color: #409eff;
    }

    &.active {
      background-color: #409eff;
      border-color: #409eff;
      color: #fff;

      .close-icon {
        color: #fff;

        &:hover {
          background: rgba(255, 255, 255, 0.3);
          color: #fff;
        }
      }
    }

    .close-icon {
      margin-left: 6px;
      font-size: 12px;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      display: inline-block;

      &:hover {
        background: #b4bccc;
        color: #fff;
      }
    }
  }
}

.contextmenu {
  position: fixed;
  background: #fff;
  z-index: 3000;
  list-style: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  color: #303133;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
  margin: 0;
  width: 120px;

  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;

    &:hover {
      background: #f2f8ff;
      color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TagsView/index.vue